import React, { type FunctionComponent } from 'react'
import { CardWrapper, type CardWrapperProps } from './CardWrapper'
import { CardHeader, type CardHeaderProps } from './CardHeader'
import { CardBody } from './CardBody'

export interface CardProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>,
    Pick<CardWrapperProps, 'showDropShadow'>,
    Pick<CardHeaderProps, 'subtitle' | 'titleDivider'> {
  title?: string | React.ReactElement
  headerContent?: React.ReactElement
}

export const Card: FunctionComponent<CardProps> = ({ headerContent, children, title, ...rest }) => (
  <CardWrapper {...rest}>
    {(title || headerContent) && (
      <CardHeader title={title} {...rest}>
        {headerContent}
      </CardHeader>
    )}
    <CardBody>{children}</CardBody>
  </CardWrapper>
)
